<template>
    <router-view/>
</template>

<script>
export default {
    methods: {
        routerToRoute(name) {
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },
    },
}
</script>

<style>
@import '../node_modules/swiper/css/swiper.min.css';
@import '../public/css/fonts.css';

#app {
    font-family: 'Inter', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    & a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

header {
    z-index: 99;
    position: fixed;

    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;

    width: 100%;
    height: 88px;

    padding: 0 7px 0 25px;
    border-bottom: 1px solid rgba(0, 0, 0, .08);

    -webkit-transition: .3s ease;
    -o-transition: .3s ease;
    transition: .3s ease;
    background-color: #fff;
}

.swiper-container {
    max-width: 100%;
    max-height: 440px;
}

.swiper-slide {
    max-height: 440px;
}

.logo-image-mobile {
    display: none;
}

.night-mode-checkbox {
    .checkbox {
        display: none;
    }

    .switch {
        position: relative;

        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 44px;
        width: 88px;

        padding: 5px;

        background-color: #D8D8D8;
        border-radius: 50px;
        cursor: pointer;
        /* Scale the size to your need */
        transform: scale(0.7);
    }

    .switch .ball {
        position: absolute;
        top: 3px;
        left: 3px;

        background-color: #AB2321;
        border-radius: 50%;
        height: 38px;
        width: 38px;
        transform: translateX(0px);
        transition: transform 0.2s linear;
    }

    .checkbox:checked + .switch .ball {
        transform: translateX(44px);
    }

    .icon {
        position: relative;
        z-index: 1;
    }

    .fa-moon {
        margin-right: 3px;
    }

    .fa-sun {
        margin-left: 5px;
    }
}

.left-menu {
    z-index: 98;
    position: fixed;
    top: 0;

    width: 90px;
    height: 100%;

    padding-top: 110px;
    border-right: 1px solid rgba(0, 0, 0, .08);

    overflow: hidden;
    -webkit-transition: width .3s ease;
    -o-transition: width .3s ease;
    transition: width .3s ease;
    background-color: #fff;
}

.left-menu-element {
    position: relative;

    display: flex;
    align-items: center;

    width: 100%;

    padding: 22px 8px 20px 20px;

    text-align: left;
    cursor: pointer;

    &.is-active {
        background: #D8D8D8;

        &:before {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;

            width: 3px;
            background: #AB2321;
        }

        .left-menu-element-text {
            color: #fb3431;
        }
    }
}

.left-menu-element-icon {
    width: 40px;
}

.left-menu-element-text {
    margin-left: 28px;
    font-size: 1.4rem;
    font-weight: bold;
}

.left-menu:hover {
    width: 260px;
}

.main-container {
    padding: 88px 400px 4px 90px;
}

#main-content {
    width: 100%;
    max-width: 100%;
    margin: auto;
}

.cart {
    z-index: 10;
    position: fixed;
    top: 88px;
    right: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 403px;
    height: calc(100% - 88px);

    padding: 20px 0 20px 14px;
    border-left: 1px solid rgba(0, 0, 0, .08);

    background-color: #fff;
    -webkit-transition: .3s ease;
    -o-transition: .3s ease;
    transition: .3s ease;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    overflow-y: scroll;

    .form-control {
        &.is-valid, &.is-invalid {
            background-position: center right calc(.375em + .875rem);
        }
        &.is-valid {
            //border-color: #28a745 !important;
            box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25);
        }
        &.is-invalid {
            //border-color: #dc3545 !important;
            box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
        }
    }
}
.cart-box {
    height: 100%;
    max-width: 100%;
    overflow-y: auto
}

.cart-box-full {
    height: 100%;
    padding: 0 8px 0 4px;
    overflow-y: auto
}

.cart::-webkit-scrollbar, .cart-box::-webkit-scrollbar, .cart-box-full::-webkit-scrollbar {
    width: 0.2em;
}
.cart::-webkit-scrollbar-track, .cart-box::-webkit-scrollbar-track, .cart-box-full::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.cart::-webkit-scrollbar-thumb, .cart-box::-webkit-scrollbar-thumb, .cart-box-full::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}


.main-overlay {
    display: none;
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: rgba(70, 70, 70, 0.5);
    z-index: 90;
}

.info-section {
    display: flex;
    align-items: center;
}

.info-section-mobile {
    display: none;
}

.cart-section-mobile {
    display: none;
}

.slider-image {
    width: 100%;
    height: 100%;
    position: relative;
    -o-object-fit: cover;
    object-fit: cover;
}

.slider-text-section {
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 103px;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;

    max-width: 480px;

    margin: auto;
    padding-right: 4%;
    padding-top: 48px;
    padding-bottom: 48px;

    color: #ffffff;
    text-align: left;

    & h1 {
        margin-bottom: 30px;
        font-size: 3rem;
        font-weight: 900;
    }
}

.slider-text-box-description {
    max-width: 310px;
    font-size: 1.25rem;
    font-weight: 700;
    text-align: left;
}

.slide-text-box-button-section {
    width: 100%;
    margin-top: 34px;

    .add-to-card-button {
        padding: 12px 60px;
        border: unset;
        border-radius: 6px;

        font-size: 1.35rem;
        font-weight: 700;

        background: #AB2321;
    }
}

.swiper-pagination-bullet {
    width: 14px;
    height: 14px;
    background: #ffffff;
}

.swiper-pagination-bullet-active {
    background: #AB2321 !important;
}

.nightmode-section-mobile {
    display: none;
    margin-top: 14px;
}

.empty-cat-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    & img {
        width: 80px;
    }
}

.empty-cat-container-text {
    margin-top: 14px;
    color: #aaa;
    font-weight: bold;
}

.cart-badge {
    position: absolute;
    top: -2px;
    right: -6px;

    padding: 2px 8px;

    color: rgb(255, 255, 255);
    font-weight: bold;
    font-size: 0.7rem;

    background-color: #AB2321;
    border-radius: 70px;
}

.footer {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;

    width: 100%;
    margin: auto auto 0;
    padding: 24px 14px 34px;

    background: #EFECEC;
}

.footer__column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    text-align: left;
}

.footer__logo-text {
    font-size: 14px;
}


.footer__all-rights {
    font-size: 14px;
    opacity: 0.4;
}

.footer__row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 16px;
}

.footer__row-title {
    font-size: 16px;
    font-weight: 700;
}


.mob-nav-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
}

.mob-nav {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    z-index: 10;

    width: 100%;

    padding-top: 32px;
    border: 1px solid #eee;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #fff;
}

@media only screen and (max-width: 1024px) {
    header {
        z-index: 10;
        height: 70px;
        padding: 0 8px;
    }

    .logo-image {
        display: none;
    }

    .logo-image-mobile {
        display: block;
    }

    .left-menu {
        z-index: 10;
        top: auto;
        bottom: 0;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 100%;
        height: 70px;

        margin-top: 0;
        padding: 0 16px;
        border-top: 1px solid rgba(0, 0, 0, .08);

        &:hover {
            width: 100%;
        }
    }

    .left-menu-element {
        display: block;
        height: 100%;
        padding: 8px 0 4px;
        margin-bottom: 0;
        text-align: center;

        &.is-active:before {
            top: 0;
            left: 0;
            right: 0;
            bottom: unset;
            width: auto;
            height: 3px;
        }
    }

    .left-menu-element-icon {
        width: 25px;
    }

    .left-menu-element-text {
        margin: 5px 0 0 0;
        color: #000;
        font-size: 0.7rem;
    }

    .main-container {
        display: flex;
        flex-direction: column;

        min-height: 100vh;
        padding: 70px 0;
    }

    .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
        bottom: 68px;
    }

    .cart {
        display: none;
    }

    .selected-element {
        width: 31px;
    }

    .info-section {
        display: none;
    }

    .cart-section-mobile {
        display: block;
        margin-right: 12px;
    }

    .info-section-mobile {
        display: flex;
    }

    .swiper-slide {
        padding-bottom: 70px;
    }

    .slider-text-section {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        order: 2;

        align-items: center;
        max-width: 100%;
        width: 100%;
        height: 100%;

        text-align: center;

        margin: 0;
        padding: 40px 0 12px;

        & h1 {
            margin-bottom: 10px;
            font-size: 1.2rem;
            font-weight: bold;
        }
    }

    .slider-text-box-description {
        display: flex;
        flex-direction: column;

        max-width: 100%;
        width: 100%;
        height: 100%;
        padding: 0 10px;

        text-align: center;
        font-size: 0.9rem;
    }

    .slide-text-box-button-section {
        margin-top: auto;
        text-align: center;
    }

    .slide-text-box-button-section .add-to-card-button {
        width: 100%;
        margin-top: unset;
        font-size: 1.1rem;
    }

    .swiper-pagination-bullet {
        background: #000000;
    }

    .nightmode-section-mobile {
        display: block;
    }

    .footer {
        flex-direction: column;
        gap: 12px
    }

    .footer__column {
        align-items: center;
        text-align: center;
    }

    .footer__column.footer__mob-row {
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
}

.dark {
    color: #ffffff !important;
    background-color: #1c1a1a;

    & header {
        border-bottom: 1px solid #ffffff14;
        background-color: #1c1a1a;
    }

    .info-section {
        color: #fff;
    }

    .night-mode-checkbox {
        .switch {
            background-color: #000000;
        }
    }

    .left-menu {
        border-right: 1px solid #ffffff14;
        border-top: 1px solid #ffffff14;
        background: #1c1a1a;
    }

    .left-menu-element {
        &.is-active {
            background: #262323;

            .left-menu-element-text {
                color: #fb3431;
            }
        }
    }

    .left-menu-element-text {
        color: #fff;
    }

    .cart {
        background: #1c1a1a;
        color: #fff;
        border-left: 1px solid #ffffff14;

        .form-control {
            background-color: #ffffff05;
            border: 1px solid #ffffff14;
            color: #fff;
        }
    }

    .center-cart-section {
        color: #ffffff;
    }

    .page-title {
        color: #ffffff;
    }

    .product-box {
        border: 1px solid #ffffff0a;

        background: #262323;
    }

    .product-box-title {
        color: white;
    }

    .product-box-description {
        color: #aaaaaa;
    }

    .product-box-price-section .add-to-card-button {
        border: 1px solid #fff;
        background-color: unset;
    }

    .add-product-modal {
        border: 1px solid #262323;

        background: #262323;
        color: #fff;
    }

    .add-product-modal-title {
        color: #ffffff;
    }

    .ingredients-button {
        border: 1px solid #eee;
        color: #fff;
    }

    .beverage-box {
        border: 1px solid #ffffff0a;
        background: #262323;
        color: #ffffff;
    }

    .beverage-box-title {
        margin-top: 14px;
        color: #ffffff;
    }

    .cart-quanity-box {
        border: 1px solid #ffffff14;
        color: #fff;
        background-color: #ffffff05;
    }

    .form-control {
        border: 1px solid #ffffff14;
        background-color: #ffffff05;
        color: #fff;
    }

    & input {
        border: 1px solid #ffffff14 !important;
        color: #fff;
        background-color: #ffffff05;
    }

    & option {
        color: #495057;
    }

    .info-modal {
        border: 1px solid #1c1a1a;
        background-color: #1c1a1a;
    }
    .mob-nav {
        border: 1px solid #1c1a1a;
        background-color: #1c1a1a;
    }

    .slider-text-section {
        color: #fff;
    }

    .cart-free-beverage-box {
        border: 1px solid #ffffff0a;
        background: #262323;
    }

    .cart-order-type-box {
        border: 1px solid #ffffff0a;
        background: #0C0C0C;
    }

    .order-type-text-selected {
        color: #fff;
    }

    .street-suggestions-section {
        color: #495057;
    }

    .footer {
        background: rgba(0,0,0,0.1);
    }
}
</style>
